import { axiosService } from 'service'
import { accountingCheckEndpoints } from 'service/sources'

const listOwnChecks = (options) => {
  return axiosService.get(accountingCheckEndpoints.OWNLIST + options)
}

const listThirPartyChecks = (options) => {
  return axiosService.get(accountingCheckEndpoints.THIRDPARTYLIST + options)
}

export const accounting = {
  listOwnChecks,
  listThirPartyChecks,
}
